export interface IProjectCurrency {
  currency: string;
  currency_multiplication: string;
}
